'use client';

import NextLink from 'next/link';
import { styled } from '@mui/material/styles';
import { focusRingOnDark } from '@/lib/focusRing';

/**
 * Shell shared by both Get Started cards. Previously the Search card used a
 * plain inline style object, which cannot express `:focus-visible` — it fell
 * back to the UA's near-black ring and vanished against the dark section while
 * its Registry sibling showed a blue one.
 */
export const GetStartedCardLink = styled(NextLink)({
  position: 'relative',
  display: 'flex',
  flexDirection: 'column',
  flex: 1,
  minHeight: 0,
  height: '100%',
  textDecoration: 'none',
  borderRadius: '16px',
  '&:focus-visible': focusRingOnDark,
});
